export default "__VITE_PUBLIC_ASSET__4458e563__"